import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

export const policyTemplateNamedLocationRequirementsApi = createApi({
  reducerPath: 'policyTemplateNamedLocationRequirements',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getNamedLocationRequirementsPreview: builder.query({
      query: ({ templateId, customerId }) => ({
        url: `/secure/policy/template/${templateId}/named-location-requirements/preview`,
        params: { customerId },
      }),
    }),
  }),
})

export const { useGetNamedLocationRequirementsPreviewQuery, useLazyGetNamedLocationRequirementsPreviewQuery } =
  policyTemplateNamedLocationRequirementsApi

export const useNamedLocationRequirementsPreview = ({ templateId, customerId: customerIdOverride }, options = {}) => {
  const selectedCustomerId = useSelector(getSelectedCustomerId)
  const customerId = customerIdOverride ?? selectedCustomerId

  return useGetNamedLocationRequirementsPreviewQuery(
    { templateId, customerId },
    { ...options, skip: options.skip || !templateId || !customerId },
  )
}
